// Copyright (c) 2016 Deere & Company

import './download-to-excel.scss';
import PropTypes from 'prop-types';
import React from 'react';

const DownloadToExcel = ({ onDownload }) => (
    <div className="download-to-excel">
        <span
            className="excel-icon"
            onClick={onDownload}
        />
    </div>
);

DownloadToExcel.displayName = 'DownloadToExcel';
DownloadToExcel.propTypes = {
    onDownload: PropTypes.func.isRequired,
};

export default DownloadToExcel;
